<div class="eone-tier-upgrade-card-plugin" hive-root>
    <svg [hive-svg]="renderInfo().recommendedLicenseSvg" [height]="80" [width]="285"></svg>
    <div class="eone-tier-upgrade-card-plugin__recommended-license">
        {{ renderInfo().recommendedLicenseType }}
    </div>
    <div class="eone-tier-upgrade-card-plugin__message">
        {{ renderInfo().reason }}
    </div>
</div>
